import React from 'react';

function Title(props) {
    return (
        <div className="text-center p-2 pb-0">
            <h1>Beat-It</h1>
            <h6>Whack-a-Mole game made with ReactJs</h6>
            <h6><small>Thejeshwar AB &copy;</small></h6>
            <br />
        </div>
    );
}

export default Title;